<template>
      <NavBars />
    <EinstellungenTab />
</template>

<script>
import { defineComponent } from 'vue';

// Components
import NavBars from '@/components/NavBars.vue';
import EinstellungenTab from '@/components/EinstellungenTab.vue';

export default defineComponent({
  name: 'wTool',

  components: {
    NavBars, EinstellungenTab
  },
});
</script>